import RingLoader from "../../Loaders/RingLoader";
import cn from "classnames";

const Button = ({ isDisabled = false, loading, children, onClick, className, ...rest }) => {
    const buttonClasses = cn(
        className, 
        "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full active:bg-blue-700 items-center",
        {
            "cursor-not-allowed opacity-50": isDisabled
        });
    return (
        <button
            disabled={isDisabled}
            type="button"
            className={buttonClasses}
            onClick={onClick}
            {...rest}
        >
            <div className="flex flex-row gap-1 items-center justify-center">
                {loading && <RingLoader size={20}/> }
                {children}
            </div>
        </button>
    );
};

export default Button;